"use strict";

let scrollContentEl = $(window);

$.fn.isInViewport = function() {
	var res = 0;
	var self = $(this);

	// debugger;

	var scrollElHeight = scrollContentEl.height();

	var viewportTop = scrollContentEl.scrollTop();
	var viewportBottom = viewportTop + scrollElHeight;

	var elementTop = self.position().top;// + viewportTop;
	var elementBottom = elementTop + self.height();

	if (viewportTop !== 0) {
		elementTop += scrollElHeight * (0.38196601125 / 2);
	}

	if (elementTop <= viewportBottom) {
		res = 1;
	}

	return res;
};

window.HeroEffects = function(el, paused) {
	if (typeof paused === 'undefined') {
		paused = false;
	}

	var t = new TimelineMax({
		paused: paused
	});

	var scrambleEl;

	if (!el.hasClass('_scramble')) {
		scrambleEl = el.find('._scramble');
	} else {
		scrambleEl = el;
	}

	var scrambleElChilds;
	var timeStart = 0;

	for (var i = 0, l = scrambleEl.length; i < l; ++i) {
		// scrambleEl[i] = scrambleEl[i];
		scrambleEl[i]._scrambleQueue = 0;

		if (scrambleEl[i]._scrambleQueue) {
			// timeStart = 1.6 * scrambleEl[i]._scrambleQueue;
		}

		t.fromTo(scrambleEl[i], 0.64, {
			y: 40,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			ease: Power2.easeOut,
			clearProps: "transform"
		}, timeStart);

		scrambleElChilds = $(scrambleEl[i]).find('span');

		if (scrambleElChilds.length) {
			scrambleEl[i] = null;

			for (var j = 0; j < scrambleElChilds.length; ++j) {
				// scrambleElChilds[j] = scrambleElChilds[j];
				scrambleElChilds[j]._scrambleQueue = j;

				if (j) {
					// timeStart = 1.6 * j;
				}

				scrambleEl.push(scrambleElChilds[j]);

				t.to(scrambleElChilds[j], 0.64, {
					scrambleText: {
						tweenLength: false,
						text: $(scrambleElChilds[j]).text(),
						revealDelay: .24
					},
					ease: Power2.easeOut
				}, timeStart);
			}
		} else {
			t.to(scrambleEl[i], 0.64, {
				scrambleText: {
					tweenLength: false,
					text: $(scrambleEl[i]).text(),
					revealDelay: .24
				},
				ease: Power2.easeOut
			}, timeStart);
		}

		timeStart = 0;
	}



	var fadeInEl;

	if (!el.hasClass('_fade-in')) {
		fadeInEl = el.find('._fade-in');
	} else {
		fadeInEl = el;
	}



	var fadeInElChilds;
	var timeStart = 0;
	var splittedText, words;

	for (var i = 0, l = fadeInEl.length; i < l; ++i) {
		// fadeInEl[i] = fadeInEl[i];
		fadeInEl[i]._fadeInQueue = 0;

		if (fadeInEl[i]._fadeInQueue) {
			// timeStart = 1.6 * fadeInEl[i]._fadeInQueue;
		}

		t.fromTo(fadeInEl[i], 0.64, {
			y: 40,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			ease: Power2.easeOut,
			clearProps: "transform"
		}, timeStart);

		fadeInElChilds = $(fadeInEl[i]).find('p');

		if (fadeInElChilds.length) {
			fadeInEl[i] = null;

			for (var j = 0; j < fadeInElChilds.length; ++j) {
				// fadeInElChilds[j] = fadeInElChilds[j];
				fadeInElChilds[j]._fadeInQueue = j;

				if (j) {
					// timeStart = 1.6 * j;
				}

				fadeInEl.push(fadeInElChilds[j]);

				splittedText = new SplitText(fadeInElChilds[j], {type: "words"});
				words = arrayShuffle(splittedText.words);

				for (var o = 0; o < words.length; o++) {
					t.from(words[o], 0.44, {opacity: 0}, .0148 * o); // TODO: clearprops
				}
			}
		} else {
			splittedText = new SplitText(fadeInEl[i], {type: "words"});
			words = arrayShuffle(splittedText.words);

			for (var o = 0; o < words.length; o++) {
				t.set(words[o], {display: 'inline'}).from(words[o], 0.44, {opacity: 0}, .0148 * o);
			}
		}

		timeStart = 0;
	}



	var fadeInBlockEl;

	if (!el.hasClass('_fade-in--block')) {
		fadeInBlockEl = el.find('._fade-in--block');
	} else {
		fadeInBlockEl = el;
	}

	if (fadeInBlockEl.length) {
		for (var o = 0; o < fadeInBlockEl.length; o++) {
			t.fromTo(fadeInBlockEl[o], 0.64, {
				autoAlpha: 0,
				y: 125
			}, {
				force3D: true,
				autoAlpha: 1,
				y: 0,
				ease: Quint.easeOut,
				clearProps: "transform"
			}, .074 * o);
		}

		var fadeInBlockInner = $(fadeInBlockEl[o]).find('._fade-in--block__inner');

		t.fromTo(fadeInBlockInner, 0.64, {
			y: -37
		}, {
			force3D: true,
			y: 0,
			ease: Quint.easeOut,
			clearProps: "transform"
		}, 0);
	}



	var hr;

	if (!el.hasClass('_hr')) {
		hr = el.find('._hr');
	} else {
		hr = el;
	}

	if (hr.length) {
		t.fromTo(hr, 0.64, {
			autoAlpha: 0,
			y: 40
		}, {
			force3D: true,
			autoAlpha: 1,
			y: 0,
			ease: Power2.easeOut,
			clearProps: "transform"
		}, 0);
	}



	var countingEl;

	if (!el.hasClass('_counting')) {
		countingEl = el.find('._counting');
	} else {
		countingEl = el;
	}

	var formatCounting = function(num) {
		var n = String(num),
			p = n.indexOf('.');

		return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) => p < 0 || i < p ? `${m} ` : m);
	};

	if (countingEl.length) {
		for (var o = 0; o < countingEl.length; o++) {
			countingEl[o].$el = $(countingEl[o]);
			countingEl[o]._counting = countingEl[o].$el.data('counting');
			countingEl[o]._noformat = countingEl[o].$el.data('no-format') !== undefined;

			if (!countingEl[o]._counting) {
				countingEl[o]._counting = 0;
			}

			t.set(countingEl[o], {
				opacity: 1
			}, .074 * o);

			t.to(countingEl[o], 1.6, {
				_counting: parseInt(countingEl[o].$el.text().replace(' ', ''), 10),
				onUpdate: function (o) {
					var num = Math.ceil(countingEl[o]._counting);

					if (!countingEl[o]._noformat && num > 999) {
						num = formatCounting(num);
					}

					countingEl[o].$el.text(num);
				},
				onUpdateParams: [
					o
				],
				ease: Circ.easeOut
			}, .074 * o);
		}
	}




	var flipEl;

	if (!el.hasClass('_flip')) {
		flipEl = el.find('._flip');
	} else {
		flipEl = el;
	}

	if (flipEl.length) {
		for (var o = 0; o < flipEl.length; o++) {
			t.set(flipEl[o], {
				transformOrigin: '50% 100%',
				transformPerspective: 900
			});

			t.fromTo(flipEl[o], 1.2, {
				autoAlpha: 0,
				rotationX: 90
			}, {
				autoAlpha: 1,
				rotationX: 0,
				x: 0,
				ease: Back.easeOut,
				clearProps: 'transform, transform-origin'
			}, .074 * o);
		}
	}


	return t;
};

const illustrationControlsInit = function() {
	const body = $('body');
	const controls = $('.illustration__controls');

	if (!controls.length) {
		return;
	}

	const slider = controls.find('.illustration__slider');
	const overlay = controls.find('.illustration__overlay');

	let overlayWidth = 240;
	let controlX = 0;

	let mouseX = 0;

	const onMouseMove = function(e) {
		mouseX = e.pageX;

		if (!mouseX) {
			mouseX = e.originalEvent.touches[0].pageX;
		}

		const controlOffset = controls.offset();
		const controlWidth = controls.width();

		controlX = controlOffset.left;

		overlayWidth = Math.max(mouseX - controlX, 3);
		overlayWidth = Math.min(overlayWidth, controlWidth - 3);

		overlay.width(overlayWidth);
	};

	slider.on('mousedown touchstart', function(e) {
		e.preventDefault();

		body.addClass('cursor-ew-resize');
		body.on('mousemove touchmove', onMouseMove);

		body.on('mouseup touchend touchcancel', function() {
			body.removeClass('cursor-ew-resize');
			body.unbind('mousemove mouseup touchmove touchend touchcancel');
		});
	});
};

const anchorInit = function() {
	const scrollEl = $('html, body');
	const header = $('.header');

	$('a[href^="#"]').click(function(e) {
		const self = $(this);
		const destId = self.attr('href');
		const destEl = $(destId);

		if (!destEl.length) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		const destElOffsetTop = destEl.offset().top;

		scrollEl.stop().animate({
			scrollTop: destElOffsetTop
		}, 500);

		if (header.hasClass('header--mobile')) {
			header.removeClass('header--mobile');
			window.enableScroll();
		}
	});
};

const modalInit = function() {
	const links = $('a[data-modal]');
	const modal = $('.modal');
	const modalWindow = modal.find('.modal__window');
	const modalContent = modal.find('.modal__content');
	const modalOverlay = modal.find('.modal__overlay');
	const modalClose = modal.find('.modal__close');
	const predefinedModals = $('.predefined-modals');

	links.click(function(e) {
		const self = $(this);
		const modalName = self.data('modal');

		let isCloseButtonHidden = self.data('modal-close');
		isCloseButtonHidden = isCloseButtonHidden === 'true' || isCloseButtonHidden;

		let modalHtml = predefinedModals.find('.predefined-modals__' + modalName);

		if (!modalHtml.length) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		if (isCloseButtonHidden) {
			modalClose.hide();
		} else {
			modalClose.show();
		}

		modalHtml = modalHtml.clone();
		modalContent.html(modalHtml);

		modal.show();

		const modalWidth = modalWindow.width();
		const modalHeight = modalWindow.height();

		modalWindow.css({
			marginTop: Math.round(modalHeight / -2),
			marginLeft: Math.round(modalWidth / -2),
		});

		formInit();
	});

	modalClose.click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		modal.hide();
	});

	modalOverlay.click(function (e) {
		e.preventDefault();
		e.stopPropagation();

		modalClose.trigger('click');
	});
};

const mobileInit = function() {
	const ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	// const android = /(android)/i.test(navigator.userAgent);

	window.gestures = {
		touch: null,
		state: false,
		route: function(e) {
			const zoom = document.documentElement.clientWidth / window.innerWidth;
			if (zoom !== 1) return;

			if (e.type === 'right') {
				// sidebarOpen();
			} else if (e.type === 'left') {
				// sidebarClose();
			}
		},
		enable: function() {
			if (gestures.state) return;

			(function(d) {
				let ce, ignore, block, scrollOffset, startPoint, currentPoint, touch, previousPoint;

				ce = function(e, n) {
					let a = document.createEvent('CustomEvent');
					a.initCustomEvent(n, true, true, e.target);
					e.target.dispatchEvent(a);
					a = null;
					return false
				};

				ignore = false;
				block = false;
				scrollOffset = null;

				startPoint = {
					x: 0,
					y: 0,
					time: null,
					scrollOffset: 0
				};

				currentPoint = {
					x: 0,
					y: 0,
					time: null,
					scrollOffset: 0
				};

				touch = {
					touchstart: function(e) {
						startPoint.x = e.touches[0].screenX,
							startPoint.y = e.touches[0].screenY,
							startPoint.time = new Date().getTime();
						startPoint.scrollOffset = window.pageYOffset;

						ignore = false;
					},
					touchmove: function(e) {
						let x, xDiff, y, yDiff, xTrashhold, timeDiff, xSpeed, eventType;
						let SPEED_COEF = 1.3;

						// if (isMenuOpened) {
						// 	SPEED_COEF = 1.8;
						// }

						if (ignore || !e.cancelable || e.target.className === 'fill' || e.target.dataset.notouch) {
							return;
						}

						if (block) {
							if (e.cancelable) {
								e.preventDefault();
								e.stopPropagation();
							}

							return false;
						}

						currentPoint.scrollOffset = window.pageYOffset;
						currentPoint.y = e.touches[0].screenY,

							y = currentPoint.y - startPoint.y;
						yDiff = Math.abs(y);

						if (startPoint.scrollOffset !== currentPoint.scrollOffset ||
							(startPoint.scrollOffset === 0 && y > 5) ||
							yDiff > 7) {
							ignore = true;
							return;
						}

						currentPoint.x = e.touches[0].screenX,
							currentPoint.time = new Date().getTime();

						x = currentPoint.x - startPoint.x;
						xDiff = Math.abs(x);

						timeDiff = currentPoint.time - startPoint.time;

						xSpeed = (xDiff / timeDiff) * SPEED_COEF;

						if (xSpeed > 1) {
							xSpeed = 1;
						}

						if (xSpeed < 0.15) {
							ignore = true;
							return;
						}

						xTrashhold = 150 * (1 - xSpeed);

						if (xDiff > xTrashhold && xDiff > 16) {
							eventType = x < 0 ? 'left' : 'right';

							if (eventType) {
								block = true;
								ignore = false;

								ce(e, eventType);
							}
						}
					},
					touchend: function(e) {
						block = false;
						ignore = false;
					},
					touchcancel: function(e) {
						block = false;
						ignore = false;
					}
				};

				for (const a in touch) {
					d.addEventListener(a, touch[a], {
						passive: a !== 'touchmove'
					});
				}

				gestures.touch = touch;
				gestures.state = true;
			})(document);

			document.addEventListener('left', gestures.route, false);
			document.addEventListener('right', gestures.route, false);
		},
		disable: function() {
			if (!gestures.state) return;

			document.removeEventListener('left', gestures.route, false);
			document.removeEventListener('right', gestures.route, false);

			for (var a in gestures.touch) {
				document.removeEventListener(a, gestures.touch[a], {
					passive: a !== 'touchmove'
				});
			}

			gestures.state = false;
		}
	};

	gestures.enable();

	const disableScrollTouchStart = function(event) {
		this.allowUp = (this.scrollTop > 0);
		this.allowDown = (this.scrollTop < this.scrollHeight - this.clientHeight);
		this.slideBeginY = event.pageY;
	};

	const disableScrollTouchMove = function(event) {
		const up = (event.pageY > this.slideBeginY);
		const down = (event.pageY < this.slideBeginY);

		this.slideBeginY = event.pageY;

		if ((up && this.allowUp) || (down && this.allowDown)) {
			event.stopPropagation();
		} else {
			event.preventDefault();
		}
	};

	let xStart, yStart = 0;

	const disableDocumentTouchStart = function(e) {
		xStart = e.touches[0].screenX;
		yStart = e.touches[0].screenY;
	};

	const disableDocumentTouchMove = function(e) {
		if (ios) {
			if (e.cancelable) {
				e.preventDefault();
				e.stopPropagation();
			}

			return false;
		}

		const target = $(e.target);
		if (!target.data('noscroll')) {
			return;
		}

		const xMovement = Math.abs(e.touches[0].screenX - xStart);
		const yMovement = Math.abs(e.touches[0].screenY - yStart);

		if ((yMovement * 3) > xMovement) {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	window.disableScroll = function() {
		if (ios) {
			$('._scrollable').each(function() {
				this.addEventListener('touchstart', disableScrollTouchStart, false);
				this.addEventListener('touchmove', disableScrollTouchMove, false);
			});
		} else {
			// $('html,body').css({
			//   height: $(window).height()
			// });
		}

		document.addEventListener('touchstart', disableDocumentTouchStart, false);
		document.addEventListener('touchmove', disableDocumentTouchMove, false);

		$('body').addClass('scrollbar-locked');

		// var vpContent = vp.attr('content');
		// vp.attr('content', vpContent + ', maximum-scale=1.0, user-scalable=no');
	};

	window.enableScroll = function() {
		if (ios) {
			$('._scrollable').each(function() {
				this.removeEventListener('touchstart', disableScrollTouchStart, false);
				this.removeEventListener('touchmove', disableScrollTouchMove, false);
			});
		} else {
			// $('html,body').css({
			//   height: ""
			// });
		}

		document.removeEventListener('touchstart', disableDocumentTouchStart, false);
		document.removeEventListener('touchmove', disableDocumentTouchMove, false);

		$('body').removeClass('scrollbar-locked');

		// var vpContent = vp.attr('content');
		// vp.attr('content', vpContent.replace(', maximum-scale=1.0, user-scalable=no', ''));
	};

	if (ios) {
		$('body').addClass('ios');
	}

	const header = $('.header');
	const headerHamburger = $('.header__hamburger');

	let isMenuOpened = false;

	headerHamburger.click(function() {
		if (!isMenuOpened) {
			// Open menu
			header.addClass('header--mobile');
			window.disableScroll();

			isMenuOpened = true;
		} else {
			// Close menu
			header.removeClass('header--mobile');
			window.enableScroll();

			isMenuOpened = false;
		}
	});
};

const formInit = function() {
	const fi = $('.contact-form__input');

	const checkValue = function(e, v) {
		if (v === '') {
			e.addClass('err');
			return;
		}

		e.removeClass('err');
	};

	const notify = function(params) {
		const message = params['message'];
		const modalWindow = $('.modal__window');
		const modalNotice = modalWindow.find('.contact-form__notification');

		modalNotice.html(message).addClass('is-active');

		const modalWidth = modalWindow.width();
		const modalHeight = modalWindow.height();

		modalWindow.css({
			marginTop: Math.round(modalHeight / -2),
			marginLeft: Math.round(modalWidth / -2),
			width: modalWidth
		});
	};

	const notifyClose = function() {
		const modalNotice = $('.modal-notice');

		setTimeout(function() {
			modalNotice.removeClass('is-active');

			const modal = $('.modal');
			const modalOpened = modal.length && modal.hasClass('is-active');

			if (!modalOpened) {
				gestures.enable();
				$('body').removeClass('scrollbar-locked');
			}
		}, 250);
	};

	$('.modal-notice__overlay, .modal-notice__close').click(notifyClose);

	const checkLabel = function(self, manual) {
		self = manual !== 'manual' ? $(this): self;

		if (self.val() !== "") {
			self.parent().addClass('is-dirty');
			return;
		}

		self.parent().removeClass('is-dirty');
	};

	fi.on('focus blur change', checkLabel);

	// $('.form-box__button').click();

	const formBoxButton = $('.modal .contact-form__button');

	formBoxButton.click(function(e) {
		// e.preventDefault();

		const self = $(this);

		self.addClass('is-loading');
	});

	const formBox = $('.modal .contact-form__form');

	formBox.submit(function(e) {
		e.preventDefault();

		window.formSubmit();
	});

	window.formSubmit = function(recaptchaKey) {
		const $form_name      = $('.modal .contact-form__input[name="name"]'),
			$form_email     = $('.modal .contact-form__input[name="email"]'),
			$form_message   = $('.modal .contact-form__input[name="comment"]'),
			$form_agreement = $('.modal .agreement__checkbox');

		const form_name_val      = $form_name.val(),
			form_email_val     = $form_email.val(),
			form_message_val   = $form_message.val(),
			form_agreement_val = $form_agreement.is(':checked') ? '1' : '';

		checkValue($form_name, form_name_val);
		checkValue($form_email, form_email_val);
		checkValue($form_agreement, form_agreement_val);

		if (!form_name_val || !form_email_val || !form_agreement_val) {
			notify({
				className: 'warning',
				message: 'Please fill out all required fields.' +
					(!form_agreement_val ? '<br> And indicate that you give consent to process your personal data.' : '')
			});

			setTimeout(function() {
				formBoxButton.removeClass('is-loading');

				if (typeof grecaptcha !== 'undefined') {
					try {
						grecaptcha.reset();
					} catch (e) {
						console.log('reCAPTCHA error');
					}
				}
			}, 100);
		} else {
			formBoxButton.addClass('is-loading');

			if (!recaptchaKey) {
				recaptchaKey = '';
			}

			$.ajax({
				url: '/send',
				type: 'POST',
				cache: false,
				data: {
					form_name:    form_name_val,
					form_email:   form_email_val,
					form_message: form_message_val,
					recaptcha_key: recaptchaKey
				},
				success: function(data) {
					if (!data) {
						notify({
							className: 'warning',
							message:   'Unknown error!'
						});
					}

					data = JSON.parse(data);

					notify(data);

					if (data.className === 'success') {
						$form_name.removeClass('err').val('');
						$form_email.removeClass('err').val('');
						$form_message.removeClass('err').val('');

						checkLabel($form_name, 'manual');
						checkLabel($form_email, 'manual');
						checkLabel($form_message, 'manual');

						// modalClose();
					}

					formBoxButton.removeClass('is-loading');
					formBoxButton.blur();

					if (typeof grecaptcha !== 'undefined') {
						try {
							grecaptcha.reset();
						} catch (e) {
							console.log('reCAPTCHA error');
						}
					}
				},
				error: function() {
					formBoxButton.removeClass('is-loading');
					formBoxButton.blur();
				}
			});
		}
	};
};

const effectsInit = function() {
	if (scrollContentEl.width() <= 1000) {
		return;
	}

	let scrollPoints = $('._scroll-point');

	for (let fi = 0, fl = scrollPoints.length, ivp = 0; fi < fl; ++fi) {
		if (typeof scrollPoints[fi]._played === 'undefined') {
			scrollPoints[fi]._played = -1;
			scrollPoints[fi]._timeline = null;
		}

		if (!scrollPoints[fi]._timeline) {
			scrollPoints[fi]._timeline = window.HeroEffects($(scrollPoints[fi]), true);
		}

		if (scrollPoints[fi]._played === -1) {
			ivp = $(scrollPoints[fi]).isInViewport();

			if (ivp === 1) {
				scrollPoints[fi]._timeline.delay(.35).play();
				scrollPoints[fi]._played = 1;
			}
		}
	}

	let scrollTimeout;

	scrollContentEl.scroll(() => {
		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			for (let fi = 0, fl = scrollPoints.length, ivp = 0; fi < fl; ++fi) {
				if (scrollPoints[fi]._played !== -1) {
					continue;
				}

				ivp = $(scrollPoints[fi]).isInViewport();

				if (ivp === 1) {
					scrollPoints[fi]._timeline.delay(.25).play();
					scrollPoints[fi]._played = 1;
				}
			}
		}, 16);
	});
};

const attentionEffectInit = function() {
	const attention = $('._attention');

	if (!attention.length) {
		return;
	}

	$('._attention-group').on('mouseover touchstart', function() {
		const attentionItems = $(this).find('._attention');

		if (!attentionItems.first().hasClass('_attention--stopped')) {
			attentionItems.addClass('_attention--stopped');
		}
	});

	attention.on('mouseover touchstart', function() {
		const self = $(this);

		if (!self.hasClass('_attention--stopped')) {
			self.addClass('_attention--stopped');
		}
	});

	const attentionButton = $('._attention-button');

	if (!attentionButton.length) {
		return;
	}

	const highlightButton = function(element, className) {
		setTimeout(function() {
			element.addClass(className);

			setTimeout(function() {
				element.removeClass(className);

				setTimeout(function() {
					element.addClass(className);

					setTimeout(function() {
						element.removeClass(className);
					}, 250);
				}, 50);
			}, 250);
		}, 450);
	};

	setInterval(function() {
		highlightButton(attentionButton, '_attention-button--highlighted');
	}, 4000);
};

const photoSwipeInit = function() {
	var $pswp = $('.pswp')[0];
	var image = [];

	$('._photo-gallery').each(function() {
		var $pic     = $(this),
			getItems = function() {
				var items = [];
				var $pic_a = $pic.find('a');

				$pic_a.each(function() {
					var sizeData = $(this).data('size');

					if (!sizeData) {
						return;
					}

					var $href    = $(this).attr('href'),
						$size    = sizeData.split('x'),
						$slider  = $(this).data('slider'),
						$caption = $(this).find('figcaption'),
						$width   = $size[0],
						$height  = $size[1],
						$msrc    = $(this).find('img').attr('src');

					$slider || ($slider = false);

					// debugger;

					var item = {
						// msrc: $msrc,
						src:    $href,
						w:      $width,
						h:      $height,
						slider: $slider
					};

					if ($caption.length) {
						item.title = $caption.html();
					}

					item.el = $(this).find('img')[0];

					items.push(item);
				});

				return items;
			};

		var items = getItems();

		// console.log(items);

		/*$.each(items, function(index, value) {
				image[index]     = new Image();
				image[index].src = value['src'];
		});*/

		$pic.on('click', 'a', function(event) {
			event.preventDefault();
			event.stopPropagation();

			var $index = $(this).data('index');
			var options = {
				index: $index,
				bgOpacity: 1,
				showHideOpacity: true,
				getThumbBoundsFn: function(index) {
					var thumbnail = items[index].el,
						pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
						rect = thumbnail.getBoundingClientRect();

					/*var thumbnailWidth = $(thumbnail).width();
					var thumbnailHeight = $(thumbnail).height();

					var height = Math.floor((thumbnailWidth * items[index].h) / items[index].w);

					var heightDiff = height - thumbnailHeight;

					if (heightDiff > 0) {
						heightDiff /= 2;
					} else {
						heightDiff /= 2;
					}

					var y = (rect.top + pageYScroll) - heightDiff;*/

					// debugger;

					return {
						x: rect.left,
						y: rect.top + pageYScroll,
						w: rect.width
					};
				}
			};

			var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);

			lightBox.init();

			lightBox.listen('afterChange', function() {
				if (lightBox.currItem.slider) {
					cs.trigger('to.owl.carousel', [lightBox.getCurrentIndex(), 0]);
				}
			});

			gestures.disable();

			lightBox.listen('close', function() {
				gestures.enable();
			});
		});
	});

	var photoswipeParseHash = function() {
		var hash = window.location.hash.substring(1),
			params = {};

		if(hash.length < 5) {
			return params;
		}

		var vars = hash.split('&');
		for (var i = 0; i < vars.length; i++) {
			if(!vars[i]) {
				continue;
			}
			var pair = vars[i].split('=');
			if(pair.length < 2) {
				continue;
			}
			params[pair[0]] = pair[1];
		}

		if(params.gid) {
			params.gid = parseInt(params.gid, 10);
		}

		return params;
	};

	function removeHash() {
		var scrollV, scrollH, loc = window.location;
		if ("pushState" in history)
			history.pushState("", document.title, loc.pathname + loc.search);
		else {
			// Prevent scrolling by storing the page's current scroll offset
			scrollV = document.body.scrollTop;
			scrollH = document.body.scrollLeft;

			loc.hash = "";

			// Restore the scroll offset, should be flicker free
			document.body.scrollTop = scrollV;
			document.body.scrollLeft = scrollH;
		}
	}

	// Parse URL and open gallery if it contains #&pid=3&gid=1
	var hashData = photoswipeParseHash();
	if(hashData.pid && hashData.gid) {
		removeHash();
	}
};

$(function() {
	effectsInit();
	anchorInit();
	illustrationControlsInit();
	modalInit();
	mobileInit();
	attentionEffectInit();
	photoSwipeInit();
	// formInit();
});



//////////////////
// WEBPACK FOOTER
// ./src/javascript/main.js
// module id = 7
// module chunks = 0